import { linkAnchorColor } from '../../../../md/assets/jss/material-dashboard-pro-react';
import assocGroupStyles from '../components/assocGroupStyles';

const facePageStyles = (theme) => ({
  ...assocGroupStyles(theme),
  root: {
    width: '100%',
    height: '100vh',

    // Copper seems to have a .css file that defines a lot of html tags
    // in a default way.  Since we're not doing that, we'll try to accomplish
    // some of the same things here.
    '& div, input': {
      // fontSize: "100%",
    },
  },
  columnHolder: {
    // first two were specified explicitly on element in copper
    height: '100%',
    // position: "relative",
    // margin: 0,
    minWidth: 'calc(1000px - 60px)',
    backgroundColor: '#eee',
    // boxShadow: "0 0 30px rgba(0,0,00.25)",
  },
  sideColumnStructure: {
    backgroundColor: '#fff',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0,
    overflowY: 'auto',
    position: 'relative',
    paddingBottom: '24px',
  },
  entityProfileFrame: {
    backgroundColor: '#fff',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexFlow: 'column nowrap',
    boxShadow: '0 1px 1.5px 0 rgba(0,0,0,0.12)',
    // flexGrow: 1,
    // flexShrink: 0,
    // flexBasis: 0,
    // overflowY: "auto",
    // position: "relative",
    // paddingBottom: "24px",
    '&:not($entityProfileFrame_preview):not($entityProfileFrame_extension)': {
      '& $entityProfileFrame_headerBox': {
        height: '100px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexFlow: 'row-reverse nowrap',
        borderBottom: '1px solid #dce3e6',
      },
      '& $entityProfileFrame_headerActionsBox': {
        width: '82px',
      },
      '& $entityProfileFrame_titleBoxContainer': {
        width: 'calc(100%)',
      },
      '& $profileImageComponent_circle': {
        height: '36px',
        width: '36px',
        alignSelf: 'center',
        transition: 'width .3s,height .3s',
      },
    },
  },
  profileImageComponent: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    textAlign: 'center',
    backgroundColor: '#dce3e6',
    color: 'rgba(12, 13, 13, 0.64)',
    position: 'relative',
    fontSize: 0,
    lineHeight: 0,
    '&$profileImageComponent_circle': {
      '& profileImageComponent_image': {
        borderRadius: '50%',
      },
    },
  },
  profileImageComponent_circle: {
    borderRadius: '50%',
  },
  profileImageComponent_image: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    '&>img': {
      height: '100%',
    },
  },
  profileImageComponent_overlay: {},
  profileImageComponent_initials: {
    fontSize: '16px',
    fontWeight: 500,
    verticalAlign: 'middle',
    left: 0,
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  entityProfileFrame_organization: {},
  entityProfileFrame_headerBox: {
    color: '#fff',
    flex: '0 0 auto',
    height: '160px',
    padding: '0 10px',
    position: 'relative',
  },
  entityProfileFrame_contentBox: {
    position: 'relative',
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    flexFlow: 'column nowrap',
    overflow: 'hidden',
  },
  entityDetails: {
    color: '#0c0d0d',
    lineHeight: '24px',
    padding: '25px 25px 85px',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0,
    overflowY: 'auto',
  },
  formFramework_container: {},
  formFramework_profileContainer: {},
  formFramework_layout: {
    margin: '0 -10px',
    lineHeight: 'normal',
  },
  formFramework_listLayout: {},
  formFramework_listRow: {
    // paddingBottom: "14px",
  },
  formFramework_wrapper: {
    position: 'relative',
    flex: '1 0',
    paddingBottom: '20px',
    margin: '0 10px',
    color: '#696e6f',
    '& $formFramework_label>label': {
      display: 'flex',
      alignItems: 'center',
    },
    '&.isRequired>$formFramework_label>label': {
      '&::after': {
        marginLeft: '4px',
        content: "'•'",
        lineHeight: '14px',
        color: '#b50814',
      },
    },
    '& $formFramework_label': {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 400,
      // marginBottom: "5px",
      color: 'rgba(0,0,0,0.54)',
    },
  },
  formFramework_editWrapper: {},
  formFramework_label: {},
  formFramework_content: {},
  formFramework_item: {
    flex: '1 1 auto',
  },
  fixedAttributeLabel: {
    color: '#0c0d0d',
  },
  fixedAttributeValue: {
    fontWeight: 400,
    marginLeft: '12px',
    marginTop: '4px',
  },
  formFramework_businessTypeItem: {},
  muiTextField: {
    // make all of these precise
    // marginLeft: spacing(1),
    // marginRight: spacing(1),
    // width: "200px",

    // the first two are inherited
    // marginLeft: 0,
    // marginRight: 0,
    width: '100%',
  },
  textFieldSupplement: {
    fontSize: '0.92rem',
  },
  formFramework_textFieldItem: {},
  entityProfileFrame_headerActionsBox: {
    height: '54px',
    width: '100%',
    position: 'relative',
    '& $entityProfileFrame_headerRightActions': {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      color: '#696e6f',
    },
    '&::after': {
      content: `''`,
      clear: 'both',
    },
  },
  entityProfileFrame_titleBoxContainer: {
    '&::after': {
      content: `''`,
      clear: 'both',
    },
  },
  entityProfileFrame_titleBox: {
    height: '58px',
    display: 'flex',
    alignItems: 'center',
    '&::after': {
      content: `''`,
      clear: 'both',
    },
  },
  entityProfileFrame_titleIcon: {
    // should be overridden as a result of a media query.
    // but I'm overriding it by hand
    // width: "50px",
    width: '36px',
    height: '50px',
    margin: '0 10px 0 15px',
    position: 'relative',
    display: 'flex',
  },
  entityProfileFrame_titleBox_text: {
    // should be overridden as a result of a media query.
    // but I'm overriding it by hand
    // width: "calc(100% - 61px)"
    width: '100%',
    display: 'flex',
    flexFlow: 'column nowrap',
  },
  entityProfileFrame_title: {
    // should be overridden as a result of a media query.
    // but I'm overriding it by hand
    // fontSize: "20px",
    // lineHeight: "28px",
    fontFamily: 'MetricWebBold',
    fontSize: '1.3rem',
    lineHeight: '22px',
    color: '#0c0d0d',
    fontWeight: 500,
  },
  entityProfileFrame_subtitle: {
    color: '#0c0d0d',
    fontSize: '13px',
    lineHeight: '19px',
    fontWeight: 400,
  },
  entityProfileFrame_subtitleName: {
    display: 'inline-block',
    maxWidth: '40%',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  entityProfileFrame_headerRightActions: {
    float: 'right',
    color: '#dce3e6',
  },
  entityProfileFrame_headerActionButton: {
    cursor: 'pointer',
    display: 'inline-block',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '20px',
    verticalAlign: 'top',
    height: '36px',
    width: '36px',
    // just to test and point out that it isn't done yet:
    backgroundColor: 'lightgray',
  },
  entityProfileFrame_preview: {},
  entityProfileFrame_extension: {},
  divMysteryDiv: {},
  summonVobFormDiv: {
    textAlign: 'right',
    marginRight: '3px',
  },
  divLeftColumn: {
    float: 'left',

    // the next two are shared with divCenterColumn and divRightColumn
    display: 'flex',
    flexFlow: 'column nowrap',

    // the next three are shared with divRightColumn
    width: '25%',
    height: '100%',
    minWidth: '300px',
  },
  divRightColumn: {
    float: 'right',

    // the next two are shared with divCenterColumn and divLeftColumn
    display: 'flex',
    flexFlow: 'column nowrap',

    // the next three are shared with divLeftColumn
    width: '25%',
    height: '100%',
    minWidth: '300px',
  },
  divCenterColumn: {
    // the next two are shared with divLeftColumn and divRightColumn
    display: 'flex',
    flexFlow: 'column nowrap',

    height: '100%',
    overflow: 'hidden',
  },
  activityColumn: {
    backgroundColor: '#eaf0f2',
    color: '#212121',
    fontSize: '1rem',
    lineHeight: '24px',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0,
    overflowY: 'auto',
    padding: '10px 15px 0',
    boxShadow: 'inset 0 1px 3.5px 0 rgba(0,0,0,0.12)',
  },
  u_boxShadow: {
    boxShadow: '0 1px 1.5px 0 rgba(0,0,0,0.12), 0 1px 6px rgba(0,0,0,0.12)',
  },
  as_darkText: {
    color: '#212121',
  },
  as_grayText: {
    color: '#757575',
  },
  js_scrollable: {},
  u_ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  u_cursorPointer: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  u_clickThrough: {
    pointerEvents: 'none',
  },
  u_displayFlex: {
    display: 'flex',
  },
  u_clearFloat: {
    clear: 'both',
  },
  ac_h4: {
    lineHeight: '24px',
    fontSize: '1rem',
    // the following is shared with all ac_h*
    fontWeight: 400,
  },
  ac_h5: {
    fontSize: '0.875rem',
    lineHeight: '20px',
    // the following is shared with all ac_h*
    fontWeight: 400,
  },
  ac_h6: {
    fontSize: '0.75rem',
    lineHeight: '20px',
    // the following is shared with all ac_h*
    fontWeight: 400,
  },
  ac_a: {
    color: linkAnchorColor,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  marginTop_3: {
    marginTop: '3px',
  },
});

export default facePageStyles;
